module.exports = __webpack_public_path__ + "assets/media/3.b404aafb.wav";